import {useSelector} from 'react-redux'
import {
  getAccommodationPageHotelId,
  getOfferCheckTriggeredForRegularOffer,
  getOfferCheckTriggeredForSplitBooking
} from 'modules/accommodation/selectors'
import {toggle} from 'opticks'

import {useGetOffersQuery} from '@daedalus/core/src/sapi/services/searchApi'

import {getAlternativeOffersQueryParams} from './selectors'

export const useGetAlternativeOffers = () => {
  const queryParams = useSelector(state => {
    const hotelId = getAccommodationPageHotelId(state)
    return getAlternativeOffersQueryParams(state, hotelId)
  })

  const isAnyOfferCheckStarted = useSelector(
    state =>
      Object.keys(getOfferCheckTriggeredForRegularOffer(state)).length > 0 ||
      Object.keys(getOfferCheckTriggeredForSplitBooking(state)).length > 0
  )

  const isExpDisabled = toggle('23442652-offer-check-on-ap-v1', true, false)

  // skip calling query if there is no offer-check queries started
  // or experiment is disabled
  const shouldSkip = isExpDisabled || !isAnyOfferCheckStarted

  useGetOffersQuery(queryParams, {
    skip: shouldSkip
  })
}
